import { render, staticRenderFns } from "./ProcedureDomainMoveIndex.vue?vue&type=template&id=62beda58&"
import script from "./ProcedureDomainMoveIndex.vue?vue&type=script&lang=ts&"
export * from "./ProcedureDomainMoveIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports